// config.js — single source of truth for API URL
// In local dev, set REACT_APP_API_URL=http://localhost:3000 in .env.development.local
export const apiURL = process.env.REACT_APP_API_URL || "https://portalapp.ummudhardha.lk";
export const apiURL1 = process.env.REACT_APP_API_URL || "https://portalapp.ummudhardha.lk";
